import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var DuplicateIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M18.813 2A3.188 3.188 0 0122 5.188v9.625A3.188 3.188 0 0118.812 18H18v.813A3.188 3.188 0 0114.812 22H5.188A3.188 3.188 0 012 18.812V9.188A3.188 3.188 0 015.188 6H6v-.813A3.188 3.188 0 019.188 2h9.624zm-4 6.125H5.187c-.586 0-1.062.476-1.062 1.063v9.624c0 .587.476 1.063 1.063 1.063h9.625c.586 0 1.062-.476 1.062-1.063V9.188c0-.586-.476-1.062-1.063-1.062zM10 9c.6 0 1 .4 1 1v3h3c.6 0 1 .4 1 1s-.4 1-1 1h-3v3c0 .6-.4 1-1 1s-1-.4-1-1v-3H6c-.6 0-1-.4-1-1s.4-1 1-1h3v-3c0-.6.4-1 1-1zm8.813-4.875H9.188c-.587 0-1.063.476-1.063 1.063L8.124 6h6.688A3.188 3.188 0 0118 9.188v6.687h.813c.586 0 1.062-.476 1.062-1.063V5.188c0-.587-.476-1.063-1.063-1.063z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
DuplicateIcon.isCarinaIcon = true;
export default DuplicateIcon;
